import { useMemo } from 'react';
import { loadZipcodeMapCache } from '../../../utils/zipcodeMapCache';

/** GeoJSON polygons from ZipcodeMap localStorage cache — no network. */
export function useCachedZipcodeGeoJson() {
  return useMemo(() => {
    const cached = loadZipcodeMapCache();
    return cached?.geoJson?.features?.length ? cached.geoJson : null;
  }, []);
}
